import { render, staticRenderFns } from "./ordererror.vue?vue&type=template&id=f5eeaed4&scoped=true"
import script from "./ordererror.vue?vue&type=script&lang=js"
export * from "./ordererror.vue?vue&type=script&lang=js"
import style0 from "./ordererror.vue?vue&type=style&index=0&id=f5eeaed4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5eeaed4",
  null
  
)

export default component.exports